import { Redirect, useHistory } from 'react-router-dom';
import { useSearchAtUpcomingEventTabQuery } from '../../generated/graphql';
import { AtSearchNoResults } from '../atoms/AtSearchNoResults';
import { LoadingBox } from '../atoms/LoadingBox';
import AtSearchEventListVertical from '../molecules/AtSearchEventListVertical';
import { tabsInfo } from '../pages/AtSearch';
import style from './AtSearchUpcomingEventList.module.scss';

interface AtSearchUpcomingEventListProps {
  keyword: string;
  page: number;
  size: number;
}

export const AtSearchUpcomingEventList = ({ keyword, page, size }: AtSearchUpcomingEventListProps) => {

  const {
    loading, error, data, refetch,
  } = useSearchAtUpcomingEventTabQuery({
    variables: { page, size, keyword },
  });

  const history = useHistory();

  const onPageChanged = (currentPage: number) => {

    history.push(`/search/${tabsInfo.upcomingEvent.url}?k=${keyword}&p=${currentPage}&s=${size}`);

  };

  const onSizeChanged = (currentSize: number) => {

    history.push(`/search/${tabsInfo.upcomingEvent.url}?k=${keyword}&p=1&s=${currentSize}`);

  };

  if (loading) {

    return <LoadingBox />;

  }

  if (error || !data?.searchFutureTvEvents) {

    return <Redirect to={{ pathname: '/500', state: { invalidURL: window.location.pathname } }} />;

  }

  const searchResults = data?.searchFutureTvEvents;

  return (
    <div className={` ${style.atSearchEventList} `}>
      {searchResults.content && searchResults.content.length > 0 && (
        <AtSearchEventListVertical
          refetch={refetch}
          page={page}
          size={size}
          tvEventPages={searchResults}
          onPageChanged={onPageChanged}
          onSizeChanged={onSizeChanged}
        />
      )}
      {(!searchResults.content || searchResults.content.length === 0) && <AtSearchNoResults />}
    </div>
  );

};
